// *For User Login
export const setUserDetail = (payload) => ({
  type: "User_Detail",
  payload
});

export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});
